import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'download',
    loadComponent: () =>
      import('./landing/download-redirect/download-redirect').then((m) => m.DownloadRedirect),
  },
  {
    // Temporary waitlist index — swap back to Home in landing.routes when waitlist ends
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./landing/waitlist/waitlist').then((m) => m.Waitlist),
  },
  {
    path: '',
    loadChildren: () => import('./landing/landing.routes').then((r) => r.LANDING_ROUTES),
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes').then((r) => r.AUTH_ROUTES),
  },
  {
    path: 'main',
    loadChildren: () => import('./pages/main/main.routes').then((r) => r.MAIN_ROUTES),
  },
  { path: '**', redirectTo: '' },
];
